import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import ApiService from 'redux/services/api-service';

export interface IState {
  loading: boolean;
  count: number;
  items: any[];
}

export const saleAggregatedEndpoints = {
  deleteAllItems: createAsyncThunk('saleAggregated/deleteAllItems', async (payload: any) => {
    const response = await ApiService.post(
      `/bulk_sales_aggregated_delete/?campaign_id=${payload.campaign_id}`,
      payload,
    );
    return response.data;
  }),
};
export const saleAggregatedSlice = createSlice({
  name: 'saleAggregated',
  initialState: {
    loading: false,
    count: 0,
    items: [],
  } as IState,
  reducers: {},
});

export const saleAggregatedActions = saleAggregatedSlice.actions;

export type SaleAggregatedSlice = {
  [saleAggregatedSlice.name]: ReturnType<(typeof saleAggregatedSlice)['reducer']>;
};
